"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.5;
  return <section id="hero" ref={ref} className="relative h-screen w-full overflow-hidden bg-background">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1548683/img/hero_editorial_cityscape.png)",
      transform: `translateY(${parallaxOffset}px)`
    }}>
        {}
        <div className="absolute inset-0 bg-background/20 backdrop-blur-[1px]" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        {}
        <h1 className={`font-display text-6xl font-normal tracking-tight text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] md:text-7xl lg:text-8xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Editorial LUMIÈRE
        </h1>

        {}
        <div className={`mt-12 h-px w-24 bg-accent transition-all delay-[300ms] duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} />

        {}
        <p className={`mt-6 font-sans text-sm uppercase tracking-widest text-muted-foreground transition-all delay-[400ms] duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Desliza para explorar
        </p>
      </div>
    </section>;
}